import { render } from "./CategoryServiceEarlyDetection.vue?vue&type=template&id=6008a578&scoped=true&ts=true"
import script from "./CategoryServiceEarlyDetection.vue?vue&type=script&lang=ts"
export * from "./CategoryServiceEarlyDetection.vue?vue&type=script&lang=ts"

import "./CategoryServiceEarlyDetection.vue?vue&type=style&index=0&id=6008a578&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6008a578"]])

export default __exports__